import { createStore, createLogger } from "vuex";
import timeSheets from "./modules/time_sheets";
import permissions from "./modules/permissions";
import navigation from "./modules/navigation";

const debug = process.env.NODE_ENV !== "production";

export const store = createStore({
  state: {
    integrated: document.currentScript?.getAttribute("integrated") != null,
  },
  getters: {
    getIntegrated: (state) => state.integrated,
  },
  modules: {
    timeSheets,
    permissions,
    navigation,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
});
